import { Component } from "react";
import { FormattedMessage } from "react-intl";

import * as Routes from "../../../generated/routes";

interface Props {
  bio: string | null | undefined;
  isEnableSettingPath?: boolean; // TODO: Remove this i/f when blog_author.tsx redesign is finished
}

export class Biography extends Component<Props> {
  render() {
    if (this.props.bio) {
      return (
        <div className="biography">
          <div className="markdownBiography" dangerouslySetInnerHTML={{ __html: this.props.bio }} />
        </div>
      );
    } else if (this.props.isEnableSettingPath) {
      return (
        <div className="biography is-biography-empty">
          <FormattedMessage id="profile.messages.prompt" />
          <a href={Routes.settingsPath()}>
            <FormattedMessage id="profile.nouns.settings" />
          </a>
        </div>
      );
    } else {
      return null;
    }
  }
}
